import React from "react";
import axios from "axios";
import Grid from '@mui/material/Grid';
import ActionAlert from '../../../../../../components/Alert/ActionAlert.jsx';
import * as c from '../../../../../../constants.jsx';
import TextCardBold from "../../../../../../components/TextComps/TextCardBold.jsx";
import TextCard from "../../../../../../components/TextComps/TextCard.jsx";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { useTheme } from "@mui/material";
import Divider from '@mui/material/Divider';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

export default function GetPhyla() {

  const theme = useTheme();

const url_phyla = `${c.API_URL}/api/mphyla`

const [phylaInfo, setPhylaInfo] = React.useState(null);
const [error, setError] = React.useState(null);

React.useEffect(() => {retrievePanel();}, []);

const retrievePanel = () => {
  axios
    .get(url_phyla)
    .then((res) => {
      setPhylaInfo(res.data);

    })
    .catch(function (error) {
      if (error.response) {
        // Request made and server responded
        setError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        setError("The request was made but no response was received.");
      } else {
        // Something happened in setting up the request that triggered an Error
        setError("Error: " + error.message);
      }
    });
};

return(
<>

 {phylaInfo ? 

       theme.palette.mode === "light" ? (
    
      <Accordion elevation={3} sx={{width: '100%', bgcolor: 'grey.C200', }}>     
    
        <AccordionSummary aria-controls="panel1-content" id="panel1-header"
           expandIcon={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip title="These are the broadest categories of bacteria in your mouth. We show the five most abundant phyla and their relative amounts. In biology, the classification hierarchy goes from: Domain → Kingdom → Phylum → Class → Order → Family → Genus → Species → Strain." >
                   <span> <IconButton sx={{ pointerEvents: 'none' }} size="small"> <InfoOutlineIcon fontSize="small" /> </IconButton> </span>
                </Tooltip>
                <ExpandMoreIcon />
              </div>
            }
        > 
           <TextCardBold textcard="TOP 5 Phyla" /> 
        </AccordionSummary> 
     
        <AccordionDetails sx={{ }}>
    
          <Grid container sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  borderRadius: '14px', }}> 
              
              <Grid size={7} sx={{pl:1, mb:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="PHYLUM" /> </Grid>
              <Grid size={5} sx={{mb:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="REL. ABUNDANCE" /> </Grid>
              <Grid size={12}> <Divider role="presentation" sx={{ mb:1, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>
    
            {phylaInfo.map((i, index) =>  
                <>
              <Grid size={6} sx={{pl:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCard textcard={i.phylum} /> </Grid>
              <Grid size={5} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>  <TextCard textcard={i.relative_abundance} /> </Grid>
        </>)}
    
        </Grid>   

    </AccordionDetails>

</Accordion>

       ) : (

      <Accordion elevation={3} sx={{width: '100%', bgcolor: 'greydark.C800', }}>     
    
        <AccordionSummary aria-controls="panel1-content" id="panel1-header"
           expandIcon={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip title="These are the broadest categories of bacteria in your gut. We show the five most abundant phyla and their relative amounts. Firmicutes and Bacteroidetes typically dominate, often comprising 90%+ of the gut microbiota. The Firmicutes/Bacteroidetes ratio is frequently studied in relation to diet, obesity, and disease. Diet, lifestyle, and medications (especially antibiotics) significantly influence the composition. In biology, the classification hierarchy goes from: Domain → Kingdom → Phylum → Class → Order → Family → Genus → Species → Strain." >
                   <span> <IconButton sx={{ pointerEvents: 'none' }} size="small"> <InfoOutlineIcon fontSize="small" /> </IconButton> </span>
                </Tooltip>
                <ExpandMoreIcon />
              </div>
            }
        > 
           <TextCardBold textcard="TOP 5 Phyla" /> 
        </AccordionSummary> 
     
        <AccordionDetails sx={{ }}>
    
          <Grid container sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  borderRadius: '14px', }}> 
              
              <Grid size={7} sx={{pl:1, mb:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="PHYLUM" /> </Grid>
              <Grid size={5} sx={{mb:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="REL. ABUNDANCE" /> </Grid>
              <Grid size={12}> <Divider role="presentation" sx={{ mb:1, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>
    
            {phylaInfo.map((i, index) =>  
                <>
              <Grid size={6} sx={{pl:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCard textcard={i.phylum} /> </Grid>
              <Grid size={5} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>  <TextCard textcard={i.relative_abundance} /> </Grid>
        </>)}
    
        </Grid>   

    </AccordionDetails>

</Accordion>

)
    

 : 

    <Grid mt={2} mb={2} justifyContent="center" container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
        <ActionAlert
            severity="warning"
            message={"Currently no information available"}
        />
        </Grid>
    </Grid>

}

{error && (
          <Grid mt={2} mb={1} justifyContent="center" container spacing={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <ActionAlert severity="error" message={error.message} />
            </Grid>
          </Grid>
)}

</> 
)
}

